import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  IconButton,
  MenuItem,
  Card,
  FormControl,
  Select,
  Stack,
  CardContent,
  CircularProgress,
} from "@mui/material";
// import { DateTimePicker } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
// import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../../api";
import moment from "moment";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/lab";
import { dateFnsFormat } from "../../../CalendarPage/constants/Calendar-constants";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { toast } from "material-react-toastify";

export default function CreateGroupBooking({
  singleSpaceInfo,
  hotelId,
  eventData,
  onClose,
  fetchBookingData,
}) {
  const checkInOutSlots = Array.from({ length: 24 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );

  const [checkinDate, setcheckinDate] = useState(new Date());
  const [checkoutDate, setcheckoutDate] = useState(new Date());
  const [calendarEventDate, setCalendarEventDate] = useState(new Date());
  const [checkinTime, setcheckinTime] = useState("09");
  const [checkoutTime, setcheckoutTime] = useState("10");
  const [numAdult, setNumAdult] = useState(1);
  const [numChild, setNumChild] = useState(0);
  const [contactPerson, setContactPerson] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [numSpaces, setNumSpaces] = useState(1);
  const [calculatedPrice, setCalculatedPrice] = useState({});
  const [availableSpaces, setAvailableSpaces] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [loader, setloader] = useState(false);

  useEffect(() => {
    if (singleSpaceInfo?.id) {
      handleSpringDataRequest(
        `core/api/v1/non-rental/get-all-non-rental-package?nonRentalTypeId=${singleSpaceInfo?.id}`
      )
        .then((res) => {
          setPackages(res);
          // setSelectedPackage(res?.[0]);
        })
        .catch((err) => {});
    }
  }, [singleSpaceInfo]);

  useEffect(() => {
    if (eventData?.startStr && eventData?.endStr) {
      const start = new Date(eventData.startStr);
      const end = new Date(eventData.endStr);

      setcheckinDate(start);
      setcheckoutDate(end);
      setCalendarEventDate(start);
      setcheckinTime(String(start.getHours()).padStart(2, "0"));
      setcheckoutTime(String(end.getHours()).padStart(2, "0"));
    }
  }, [eventData]);

  //   check-space-availability
  useEffect(() => {
    const payload = {
      hotelId: hotelId,
      checkin:
        moment(
          +singleSpaceInfo?.globalNonRentalTypeId === 4
            ? calendarEventDate
            : checkinDate
        ).format("DD-MM-YYYY") +
        " " +
        `${checkinTime}:00:00`,
      checkout:
        moment(
          +singleSpaceInfo?.globalNonRentalTypeId === 4
            ? calendarEventDate
            : checkoutDate
        ).format("DD-MM-YYYY") +
        " " +
        `${checkoutTime}:00:00`,
      spaceTypeId: singleSpaceInfo?.id,
      spaceIds: [],
    };
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/check-all-space-availability`,
      payload
    )
      .then((res) => {
        setAvailableSpaces(res);
      })
      .catch(() => {
        setAvailableSpaces([]);
      });
  }, [
    calendarEventDate,
    checkinDate,
    checkoutDate,
    checkinTime,
    checkoutTime,
    selectedPackage,
  ]);

  //   calculate-price
  useEffect(() => {
    if (availableSpaces?.length > 0) {
      const nonRentalIds = [];
      availableSpaces.forEach((item, index) => {
        if (index < numSpaces) {
          nonRentalIds.push(item?.id);
        }
      });
      const payload = {
        nonRentalIds: nonRentalIds,
        checkinDateTime:
          moment(
            +singleSpaceInfo?.globalNonRentalTypeId === 4
              ? calendarEventDate
              : checkinDate
          ).format("DD-MM-YYYY") +
          " " +
          `${checkinTime}:00:00`,
        checkoutDateTime:
          moment(
            +singleSpaceInfo?.globalNonRentalTypeId === 4
              ? calendarEventDate
              : checkoutDate
          ).format("DD-MM-YYYY") +
          " " +
          `${checkoutTime}:00:00`,
        numberOfPersons: [
          ...Array.from({ length: numAdult }, (_, i) => 1),
          ...Array.from({ length: numChild }, (_, i) => 0),
        ],
        numberOfChildren: [
          ...Array.from({ length: numAdult }, (_, i) => 0),
          ...Array.from({ length: numChild }, (_, i) => 1),
        ],
        packageId: selectedPackage?.id || null,
      };
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/non-rental-booking/calculate-price`,
        payload
      )
        .then((res) => {
          setCalculatedPrice(res);
        })
        .catch(() => {
          setCalculatedPrice({});
        });
    } else {
      setCalculatedPrice({});
    }
  }, [
    calendarEventDate,
    checkinDate,
    checkoutDate,
    checkinTime,
    checkoutTime,
    numSpaces,
    numAdult,
    numChild,
    selectedPackage,
    availableSpaces,
  ]);

  // useEffect(() => {
  //   if (singleSpaceInfo?.id) {
  //     handleSpringDataRequest(
  //       `core/api/v1/non-rental/get-non-rental-by-type-id/?typeId=${singleSpaceInfo?.id}`
  //     )
  //       .then((res) => {
  //         setSpaceRooms(res);
  //       })
  //       .catch((err) => {});
  //   }
  // }, [singleSpaceInfo]);

  const handleBooking = () => {
    if (!contactPerson?.trim()) {
      toast.error("Please enter contact person name");
      return;
    }
    if (!contactNumber?.trim()) {
      toast.error("Please enter contact number");
      return;
    }
    if (!contactEmail?.trim() || !/\S+@\S+\.\S+/.test(contactEmail)) {
      toast.error("Please enter valid email");
      return;
    }
    setloader(true);
    const spaceIds = [];
    availableSpaces.forEach((item, index) => {
      if (index < numSpaces) {
        spaceIds.push(item?.id);
      }
    });
    const payload = {
      hotelId: hotelId,
      checkin:
        moment(
          +singleSpaceInfo?.globalNonRentalTypeId === 4
            ? calendarEventDate
            : checkinDate
        ).format("DD-MM-YYYY") +
        " " +
        `${checkinTime}:00:00`,
      checkout:
        moment(
          +singleSpaceInfo?.globalNonRentalTypeId === 4
            ? calendarEventDate
            : checkoutDate
        ).format("DD-MM-YYYY") +
        " " +
        `${checkoutTime}:00:00`,
      numPeople: [
        ...Array.from({ length: numAdult }, (_, i) => 1),
        ...Array.from({ length: numChild }, (_, i) => 0),
      ],
      contactPerson: contactPerson,
      contactNumber: contactNumber,
      contactEmail: contactEmail,
      spaceCost: calculatedPrice?.totalNRPriceBeforeTax,
      spaceTax: calculatedPrice?.totalNRTaxAmount,
      personCost: calculatedPrice?.totalPRPriceBeforeTax,
      personTax: calculatedPrice?.totalPRTaxAmount,
      numChildren: [
        ...Array.from({ length: numAdult }, (_, i) => 0),
        ...Array.from({ length: numChild }, (_, i) => 1),
      ],
      childCost: calculatedPrice?.totalChildPriceBeforeTax,
      childTax: calculatedPrice?.totalChildTaxAmount,
      source: "PMS",
      spaceTypeId: singleSpaceInfo?.id,
      spaceIds: spaceIds,
      nrPackageId: selectedPackage?.id,
      nrPackageCost: calculatedPrice?.totalPKGPriceBeforeTax,
      nrPackageTax: calculatedPrice?.totalPKGTaxAmount,
    };
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/create-booking`,
      payload
    )
      .then(() => {
        fetchBookingData();
        onClose();
        setloader(false);
      })
      .catch(() => {
        toast.error("Something went wrong");
        setloader(false);
      });
  };

  return (
    <Box sx={{ width: 700, paddingX: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingY: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          Create group booking
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Card sx={{ border: "1px solid #CCC", borderRadius: 2 }}>
        <CardContent>
          <Grid container spacing={3}>
            {+singleSpaceInfo?.globalNonRentalTypeId === 4 ? (
              <Grid item xs={12} sm={12}>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                    }}
                    gutterBottom
                  >
                    Event date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat={dateFnsFormat}
                      label={"Event date"}
                      disableMaskedInput
                      mask="___ ___, ____"
                      id="booking_start"
                      name="booking_start"
                      size="small"
                      minDate={new Date()}
                      value={calendarEventDate}
                      onChange={(newValue) => {
                        setCalendarEventDate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} style={{ width: "100%" }} />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                      }}
                      gutterBottom
                    >
                      Check-in
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat={dateFnsFormat}
                        label={"Check-in"}
                        disableMaskedInput
                        mask="___ ___, ____"
                        id="booking_start"
                        name="booking_start"
                        size="small"
                        minDate={new Date()}
                        value={checkinDate}
                        onChange={(newValue) => {
                          setcheckinDate(newValue);
                          if (
                            checkoutDate &&
                            newValue &&
                            checkoutDate < newValue
                          ) {
                            setcheckoutDate(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} style={{ width: 305 }} />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "15px",
                      }}
                      gutterBottom
                    >
                      Check-out
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        id="booking_end"
                        mask="____ ___, ____"
                        disableMaskedInput
                        name="booking_end"
                        size="small"
                        minDate={checkinDate}
                        placeholder="Booking End Date"
                        label={"Checkout"}
                        variant="inline"
                        autoOk={true}
                        inputFormat={dateFnsFormat}
                        value={checkoutDate}
                        onChange={(newValue) => {
                          setcheckoutDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} style={{ width: 305 }} />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
              </>
            )}
            <Grid item xs={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-in time
                </Typography>{" "}
                <TextField
                  select
                  size="small"
                  value={checkinTime}
                  onChange={(e) => {
                    setcheckinTime(e.target.value);
                    if (
                      checkinDate?.getDate() === checkoutDate?.getDate() &&
                      e.target.value >= checkoutTime
                    ) {
                      let cOutTime = (1 + +e.target.value)
                        .toString()
                        .padStart(2, "0");
                      setcheckoutTime(cOutTime);
                    }
                  }}
                  placeholder={"Check-in time"}
                  fullWidth
                  sx={{
                    "& legend": { display: "none" }, // remove notch
                  }}
                >
                  {checkInOutSlots.map((slot) => (
                    <MenuItem key={slot} value={slot}>
                      {`${slot > 12 ? slot - 12 : +slot} ${
                        slot >= 12 ? "PM" : "AM"
                      }`}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Check-out time
                </Typography>
                <TextField
                  select
                  size="small"
                  value={checkoutTime}
                  onChange={(e) => {
                    setcheckoutTime(e.target.value);
                  }}
                  placeholder={"Check-out time"}
                  sx={{
                    "& legend": { display: "none" }, // remove notch
                  }}
                  fullWidth
                >
                  {checkInOutSlots.map((slot) => (
                    <MenuItem
                      key={slot}
                      value={slot}
                      disabled={
                        checkinDate?.getDate() === checkoutDate?.getDate() &&
                        slot <= checkinTime
                      }
                    >
                      {`${slot > 12 ? slot - 12 : +slot} ${
                        slot >= 12 ? "PM" : "AM"
                      }`}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Spaces to reserve
                </Typography>
                <TextField
                  select
                  fullWidth
                  value={numSpaces}
                  onChange={(e) => {
                    setNumSpaces(e?.target?.value);
                    setNumAdult(e?.target?.value);
                  }}
                  size="small"
                  placeholder={"Spaces to reserve"}
                  sx={{
                    "& legend": { display: "none" },
                  }}
                >
                  {Array.from(
                    { length: availableSpaces?.length },
                    (_, i) => i + 1
                  ).map((num) => (
                    <MenuItem key={num} value={num}>
                      {num}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            {+singleSpaceInfo?.globalNonRentalTypeId === 4 && (
              <Grid item xs={6}>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                    }}
                    gutterBottom
                  >
                    Adult count
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    value={numAdult}
                    onChange={(e) => {
                      setNumAdult(e?.target?.value);
                      setNumChild(numSpaces - e?.target?.value);
                    }}
                    size="small"
                    placeholder={"Adult count"}
                    sx={{
                      "& legend": { display: "none" },
                    }}
                  >
                    {Array.from({ length: numSpaces + 1 }, (_, i) => i).map(
                      (num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Box>
              </Grid>
            )}
            {+singleSpaceInfo?.globalNonRentalTypeId === 4 && (
              <Grid item xs={6}>
                <Box>
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "15px",
                    }}
                    gutterBottom
                  >
                    Child count
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    value={numChild}
                    onChange={(e) => {
                      setNumChild(e?.target?.value);
                    }}
                    disabled={true}
                    size="small"
                    placeholder={"  Child count"}
                    sx={{
                      "& legend": { display: "none" },
                    }}
                  >
                    {Array.from({ length: numSpaces + 1 }, (_, i) => i).map(
                      (num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                  gutterBottom
                >
                  Select package
                </Typography>
                <TextField
                  select
                  fullWidth
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e?.target?.value)}
                  size="small"
                  placeholder={"Select Space"}
                  sx={{
                    "& legend": { display: "none" },
                  }}
                >
                  <MenuItem value={{}}>None</MenuItem>
                  {packages.map((option) => (
                    <MenuItem key={option?.id} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "15px",
                }}
              >
                Guest Details
              </Typography>
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                value={numPeople}
                onChange={(e) => setNumPeople(e?.target?.value)}
                size="small"
                placeholder={"Number of People"}
                sx={{
                  "& legend": { display: "none" },
                }}
              >
                {Array.from(
                  { length: +spaceIds?.maxOccupancy || 1 },
                  (_, i) => i + 1
                ).map((num) => (
                  <MenuItem key={num} value={num}>
                    {num}
                  </MenuItem>
                ))}
              </TextField>
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <TextField
                placeholder="Full name *"
                fullWidth
                value={contactPerson}
                onChange={(e) => setContactPerson(e.target.value)}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                }}
                variant="outlined"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                placeholder="Phone number *"
                fullWidth
                value={contactNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  const cleanedValue = value.replace(/[^0-9+]/g, ""); // Allow only digits and +
                  setContactNumber(cleanedValue);
                }}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                }}
                variant="outlined"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                placeholder="Email address *"
                type="email"
                fullWidth
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                }}
                variant="outlined"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "15px",
                }}
              >
                Pricing
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Room amount"
                type="email"
                fullWidth
                value={calculatedPrice?.totalPriceBeforeTax || 0}
                disabled={true}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Tax amount"
                type="email"
                fullWidth
                value={calculatedPrice?.totalTaxAmount || 0}
                disabled={true}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Total amount"
                type="email"
                fullWidth
                value={calculatedPrice?.totalAmount || 0}
                disabled={true}
                size="small"
              />
            </Grid>

            {/* {calculatedPrice?.totalAmount ? (
              <Grid item xs={12}>
                <Typography variant="h6">
                  Total Price: ₹{calculatedPrice?.totalAmount}
                </Typography>
              </Grid>
            ) : null} */}

            <Grid item xs={12}>
              <Button
                variant="outlined"
                style={{
                  backgroundColor: `${"#36454F"}`,
                  color: `${"white"}`,
                  borderColor: "#36454F",
                  fontWeight: "bold",
                  textTransform: "none",
                }}
                fullWidth
                size="large"
                onClick={handleBooking}
                disabled={
                  loader ||
                  !calculatedPrice?.totalAmount ||
                  availableSpaces?.length < 1
                }
              >
                {loader ? (
                  <CircularProgress
                    size={15}
                    color="inherit"
                    sx={{ ml: 1.5 }}
                  />
                ) : (
                  `Book Now`
                )}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
